import styled from 'styled-components';

interface HeaderContainerProps {
  menuExpanded: boolean;
}

export const HeaderContainer = styled.header<HeaderContainerProps>`
  background-color: ${({ theme }) => theme.primaryColor};
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  position: fixed;
  top: 0;
  right: 0;
  left: ${(props) => (props.menuExpanded ? '215px' : '60px')};
  z-index: 90;
  transition: left 0.3s ease;
  color: ${({ theme }) => theme.white};
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
`;

export const HeaderTitle = styled.h1`
  font-size: 1.2rem;
  font-weight: 700;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  white-space: nowrap;
  color: #fff;
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 8px;
`;

export const MenuToggleButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.2s, transform 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  svg {
    transition: transform 0.3s;
  }
`;

export const MenuToggleText = styled.span`
  margin-left: 8px;
  font-size: 14px;
  font-weight: 500;

  @media (max-width: 768px) {
    display: none;
  }
`;

// Mantendo para compatibilidade
export const ToggleButton = styled(MenuToggleButton)``;
